//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';

// import created components  :
import Background from '../../../components/background/Background.jsx'
import WallyBanner from '../../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />
import PanierList from '../../../components/location/panierList/PanierList.jsx';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

//MUI :
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Alert from '@mui/material/Alert';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import TextField from '@mui/material/TextField';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import CircularProgress from '@mui/material/CircularProgress';

// API fetch
import axios from "axios";
import { baseURL, appURL } from '../../../config/api-config.js';

//data
import { openingHours } from '../../../data/location-params'

//Translate utils :
import { translator } from "../../../utils/translator.js"
//Utils 
import { getTotalPanier, getArticlePU, tarifDecimalConverter } from '../../../utils/calcul-tarif'

import { poucesConvertor } from "../../../utils/poucesConvertor.js"

import convertHoraire from '../../../utils/convert_horaire'
import { calculDuree, getDureeInfos } from '../../../utils/calcul-duree'

//// - we get infos from the DB to show editables infos for a Resa ////
function LocationMatcher() { // full page as component imported in router

    const { refLoc, idLoc } = useParams(); //id of the selected resa, in url (as string)

    const dispatch = useDispatch();
    const navigate = useNavigate();


    let [currentLoc, setCurrentLoc] = useState({});

    const lang = "fr" //global state : shopping step

    const [panier, setPanier] = useState([])
    const [client, setClient] = useState({})
    const [dbArticles, setDbArticles] = useState([])
    const [dbTailles, setDbTailles] = useState([])
    const [reponseCommentaire, setReponseCommentaire] = useState("")
    let [loading, setLoading] = useState(false);
    let [match, setMatch] = useState(false);

    //// -- At first render :
    useEffect(() => {

        /* 
                if (checkLogin() === false) {
                    navigate(`/manager/login?dest=manager`)
                } */


        async function initArticles() {
            const resp = await axios.get(`${baseURL}/article`);
            setDbArticles(resp.data);
            console.log(resp.data)

            initTailles()
        }
        initArticles()

        async function initTailles() {
            const resp = await axios.get(`${baseURL}/taille`);
            setDbTailles(resp.data);

            initLocation()
        }


        async function initLocation() {
            const resp = await axios.get(`${baseURL}/location/${idLoc}`);
            //console.log(resp.data)
            setCurrentLoc(resp.data);
            //control "sécu"
            if (resp.data.ref_location !== refLoc) {
                navigate(`/location`)
            }
        }


    }, [])
    //// --

    //// -- At first render :
    useEffect(() => {

        if (currentLoc.Client) {
            setClient(currentLoc.Client);
        }
        if (currentLoc.Paniers) {
            setPanier(currentLoc.Paniers);
        }

        if (currentLoc.created !== currentLoc.updatedAt) { //location déjà répondue
            //Next step
            navigate(`/location/match-confirm/${refLoc}/${idLoc}`)
        }

    }, [currentLoc])
    //// --


    function matchLoc(reponse) {

        setMatch(reponse)
        setLoading(true);

        console.log("matchloc")
        let body = {
            match: reponse,
            commentaire: currentLoc.commentaire + "&&" + reponseCommentaire
        }

        // modif loc
        axios.put(`${baseURL}/location/${currentLoc.id_location}`, body)
            .then((response) => {
                if (response.status === 200) { // insertion ok
                    console.log(response.data.data[0]);
                    sendMail(response.data.data[0]);
                }
                else { // probleme insertion
                    console.log("error")
                    return;
                    // ---------------
                }
            })
            .catch(error => {
                console.log(error)
                return error;
                // ---------------
            })

    }


    function sendMail(locInfos) {

        let htmlBody = mailHtmlCreator(panier, currentLoc, client, dbArticles, dbTailles, locInfos, "client")
        //let htmlBodyWally = mailHtmlCreator(panier, location, theClient, dbArticles, dbTailles, locInfos, "wally")


        let bodyClient = {
            to: client.email,
            //to: "manuel.vivion@gmail.com",
            bcc: "reservations@wallyglisse.com",
            subject: `${locInfos.match === true ? "Acceptée : " : "Refusée : "}Votre Demande de location de matériel`,
            html: htmlBody
        }

        /* let bodyWally = {
            //to:theClient.email,
            to: "manuel.vivion@gmail.com",
            bcc: "reservations@wallyglisse.com",
            subject: `Demande de location de matériel (${theClient.nom})`,
            html: htmlBodyWally
        } */


        axios.post(`${baseURL}/mailing/mail-location/client`, bodyClient)
            .then((response) => {
                if (response.status === 200) { //isnertion OK
                    //to not trigger alert message
                    console.log("envoie mail client OK")
                    setLoading(false)

                    //Next step
                    navigate(`/location/match-confirm/${refLoc}/${idLoc}`)

                    //-------------------------
                    //envoie mail à wally

                    /* 
                                        axios.post(`${baseURL}/mailing/mail-location/wally`, bodyWally)
                                            .then((response) => {
                                                if (response.status === 200) { //isnertion OK
                                                    //to not trigger alert message
                                                    console.log("envoie mail wally OK")
                                                    confirmSave(true)
                                                    //envoie mail à wally
                    
                                                }
                                                else { //mail problème vers client
                                                    setAlertMessage(alertBaseMessage + "Mail-Demande-2 " + response.status);
                                                    setShowAlert(true);
                                                    return response.status
                    
                                                }
                                            })
                                            .catch(error => {
                                                setAlertMessage(alertBaseMessage + "Mail-Demande-2B " + error.message);
                                                setShowAlert(true);
                                                return error
                                            }) */


                    //-------------------------
                }
                else { //mail problème vers client
                    console.log("error")
                    return;

                }
            })
            .catch(error => {
                console.log(error)
                return error;
            })

    }



    return (
        <div className="bg-relative">
            <Background ind={3} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner mode="location" />

                    <section>
                        <div className="main-container">

                            <div className="location-step3-infos-periode">
                                <h3>Durée de location</h3>

                                <div className="location-step3-infos-periode-content">
                                    <div>
                                        <p>Du {dayjs(currentLoc.d1).format("dddd DD/MM")} à {convertHoraire(currentLoc.h1, "horaire")}</p>
                                    </div>
                                    <div>
                                        <p>Au {dayjs(currentLoc.d2).format("dddd DD/MM")} à {convertHoraire(currentLoc.h2, "horaire")}</p>
                                    </div>
                                    <div>
                                        <h4>soit {getDureeInfos(calculDuree(currentLoc))}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="main-container">

                            <div className="location-step3-panier-title">
                                <h3>Le panier</h3>

                            </div>
                            <PanierList dbArticles={dbArticles} dbTailles={dbTailles} panierAMatcher={panier} locAMatcher={currentLoc} />

                        </div>
                        <div className="main-container">

                            <div className="location-step3-infos-client">
                                <h3>Coordonnées client</h3>

                                <div className="location-step3-infos-client-content">
                                    <div>
                                        <h4>{client.prenom + " " + client.nom}</h4>
                                        <p>{"Téléphone : " + client.tel}</p>
                                        <p>{"Email : " + client.email}</p>

                                    </div>
                                    <div>
                                        <p>{"Téléphone 2 : " + client.tel2}</p>
                                        {client.adresse_vacances != "" ?
                                            <p>{"Adresse de vacances : " + client.adresse_vacances}</p>
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="main-container">

                            <div className="location-step3-infos-client">
                                <h3>Commentaire</h3>

                                <div className="location-step3-commentaire">
                                    {currentLoc.commentaire && currentLoc.commentaire.length > 0 &&
                                        <div>
                                            <p>Commentaire du client : {currentLoc.commentaire.split("&&")[0]}</p>
                                        </div>
                                    }
                                    <p>Ajouter ce commentaire à la réponse :</p>
                                    <TextField
                                        fullWidth
                                        label="Commentaire"
                                        value={reponseCommentaire}
                                        onChange={(event) => {
                                            setReponseCommentaire(event.target.value);
                                        }}
                                    />


                                </div>

                            </div>
                        </div>

                    </section>
                    <div className="main-container location-matcher-boutons">
                        <div className="location-matcher-boutons-container">
                            <div className="location-matcher-boutons-item">
                                <Button
                                    fullWidth
                                    className="bt-reponse-refuse"
                                    variant="contained"
                                    onClick={_ => matchLoc(false)}>
                                    <DoNotDisturbIcon /> Refuser cette demande
                                </Button>
                            </div>
                            <div className="location-matcher-boutons-item">
                                <Button
                                    fullWidth
                                    className="bt-reponse-accept"
                                    variant="contained"
                                    onClick={_ => matchLoc(true)}>
                                    <CheckIcon /> Accepter cette demande
                                </Button>
                            </div>
                        </div>

                        <div className="location-matcher-boutons-loader">
                            {loading === true &&
                                <>
                                    <p>Chargement </p>
                                    <CircularProgress />
                                </>
                            }
                        </div>

                    </div>


                </div>
            </main>

        </div>

    );
}

export default LocationMatcher;



function mailHtmlCreator(panier, location, client, dbArticles, dbTailles, locInfos, destinataire) {

    function getArticle(item) {
        return dbArticles.find(article => article.id_article === item.article_id)
    }

    function getTailleInfo(taille) {
        let info = dbTailles.find(t => t.id_taille === taille).nom_taille;
        return poucesConvertor(info)
    }

    let totalPanier = getTotalPanier(dbArticles, panier, location);

    let htmlBody = `
    <html lang='fr'>

<head>
    <meta charset='UTF-8'>
    <title>Confirmation de votre réservation</title>
    <style>
    body {
        background-color: white;
        font-family: Arial, Helvetica, sans-serif;
        margin: 0;
        padding: 16px;
    }

    .zebra {
        height: 50px;
        background-image: url("https://www.wallyglisse.com/images/bande_zebra_400par50.jpg");
    }

    .wallybanner {
        position: relative;
        background: linear-gradient(#c53245, #E91E63);
        padding: 8px;
        margin-bottom: 16px;
        border-top: 4px solid white;
        width: auto;
        text-align: center;
    }



    .wallybanner-img {
        width: 80px;
        margin: 0px auto;
    }






        .main-progress-bar,
        .main-container {
            background-color: rgba(255, 255, 255, 0.8);
            border-top: 4px solid #E91E63;
            margin-bottom: 8px;
            position: relative;
            padding: 16px 8px;
        }

        .main-container {
            border: none;
            border-bottom: 2px solid #E0D5B5;
            background-color: rgba(255, 255, 255, 0.8);
            margin-bottom: 4px;
        }

        .location-step3-panier-title,
        .location-step3-infos-periode,
        .location-step3-infos-client {
            position: relative;
        }

        .location-step3-panier-title h3,
        .location-step3-infos-periode h3,
        .location-step3-infos-client h3 {
            width: 100%;
            color: #E91E63;
            text-transform: uppercase;
            text-align: center;
            padding: 8px;
            border-bottom: 1px solid #E0D5B5;
        }



        .location-step3-infos-client-content table,
        .location-step3-infos-periode-content table,
        .location-panier-list table {
            width: 100%;
        }


        .location-step3-infos-periode-content table td {
            width: 30%;
        }

        .location-step3-infos-client-content table td {
            width: 50%;
        }



        .location-step3-infos-periode-content p,
        .location-step3-infos-periode-content h4 {
            margin: 0px;
        }

        .location-panier-list {
            display: flex;
            flex-direction: column;
        }

        .location-panier-list table th,
        .location-panier-list table td,
        .location-panier-list table tr {
            margin: 0px;
        }

        .location-panier-list table {
            border-collapse: collapse
        }

        .location-panier-list table td {
            border-bottom: 3px solid #E0D5B5;
            border-right: 1px solid lightgrey;

        }

        .location-panier-list table p {
            text-align: center;
            font-size: 14px;

        }

        .location-panier-list table h3 {
            font-size: 16px;

        }

        .location-panier-list table .col1 {
            width: 64px;
        }

        .location-panier-list table .col2 p {
            text-align: left;
            margin: 0px;
        }

        .location-panier-list table .col2 h3 {
            text-align: left;
            margin: 0px;
        }

        .location-panier-list table img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .location-panier-list table .col2 {
            width: 40%;
            padding: 4px;
        }

        .location-panier-list table th {
            border-bottom: 1px solid black;
            padding: 8px 2px;
            font-size: 16px;
        }

        .location-panier-list .ligne-total {
            background-color: #E91E63;
            color: white;
        }

        .location-panier-list .ligne-discount {
            background-color: #E0D5B5;
        }

        .location-panier-list .ligne-discount .col2,
        .location-panier-list .ligne-total .col2 {
            padding: 16px 8px;
        }

        .location-panier-list .ligne-discount td,
        .location-panier-list .ligne-total td {
            border: none;
            border-right: 1px solid white;
        }

        .location-panier-list .ligne-total td p {
            font-size: 16px;
        }
        .bouton-reponse {
            background-color: #E91E63;
            border-radius: 8px;
            padding: 8px;
        }

        .bouton-reponse p {
            text-align: center;
            text-transform: uppercase;
            color: white;
            text-decoration: none !important;
        }
    </style>
</head>

<body>
    <section>

        <div class="zebra"></div>
        <div class="wallybanner"><img class="wallybanner-img"
                src="https://www.wallyglisse.com/nestor/images/logo_wally.png" alt="logo Wally Glisse">
        </div>
    </section>
    </div>
    <div class="main-container">
        <div class="location-step3-infos-periode">
            <h3 style='color:${locInfos.match === true ? 'green' : 'red'}'>${locInfos.match === true ? 'Votre demande de location de matériel a bien été acceptée' : 'Désolé, nous ne pouvons pas donner suite à votre demande'}</h3>

            <div>
                <div>
                `

    ///commentaire de réponse
    let messageList = locInfos.commentaire.split("&&");
    let messageReponse = messageList[messageList.length - 1];

    if (messageReponse.length > 0) {
        htmlBody += ` 
        <p>Message de Wally Glisse : </p>
        <p>${messageReponse}</p>
        `;
    }



    htmlBody += `
                </div>

            </div>
        </div>
    </div>
    `
    if (locInfos.match === true) { //mail wally
        htmlBody += `

            <div class="main-container">

                <div class="location-step3-infos-periode">
                    <h3>⬇️ Cliquez ci dessous pour finaliser votre location</h3>
                </div>

                <a href="${appURL + `/location/payment/${locInfos.ref_location}/${locInfos.id_location}`}" target="_blank">
                    <div class="bouton-reponse">
                        <p>Payer et finaliser votre location</p>
                    </div>
                </a>
            </div>
    `
    }
    else {
        htmlBody += `
            <div class="main-container">
             <a href="${appURL + `/location`}" target="_blank">
             <div class="bouton-reponse">
             <p>Envoyez nous une autre demande</p>
         </div>
             </a>
            </div>
    `

    }

    htmlBody += `

    <div class="main-container">
        <div class="location-step3-infos-periode">
            <h3>Durée de location</h3>

            <div class="location-step3-infos-periode-content">
                <table>
                    <tr>
                        <td>
                        <p>${dayjs(location.d1).format("dddd DD/MM")} à ${convertHoraire(location.h1, "horaire")}</p>
                        </td>
                        <td>
                        <p>Au ${dayjs(location.d2).format("dddd DD/MM")} à ${convertHoraire(location.h2, "horaire")}</p>
                        </td>
                        <td>
                        <h4>soit ${getDureeInfos(calculDuree(location))}</h4>
                        </td>
                    </tr>
                </table>

            </div>
        </div>
    </div>
    <div class="main-container">
        <div class="location-step3-panier-title">
            <h3>Votre panier</h3>

        </div>
        <div class="location-panier-list">
            <table>
                <tr>
                    <th class="col1"></th>
                    <th class="col2">Article</th>
                    <th>Taille</th>
                    <th>Quantité</th>
                    <th>P.U.</th>
                    <th>Prix HT</th>
                    <th>Prix TTC</th>
                </tr>`;


    panier.forEach(item => {
        htmlBody += ` 
                    <tr>
                    <td class="col1"><img
                            src="https://www.wallyglisse.com/nestor/images/photos/${getArticle(item).image_url.split(',')[0]}"
                            alt="${getArticle(item).description}"></td>
                    <td class="col2">
                    <h3>${getArticle(item).Type.nom_type} ${getArticle(item).Categorie.nom_categorie}</h3>
                    <p><strong>${getArticle(item).description}</strong> / ${getArticle(item).infos}</p>
                    </td>
                    <td>
                        <p>${getTailleInfo(item.taille_id)}</p>
                    </td>
                    <td>
                        <p>${item.qte}</p>
                    </td>
                    <td>
                        <p>${tarifDecimalConverter(getArticlePU(getArticle(item), dbArticles, location))}€</p>
                    </td>
                    <td>
                        <p>${tarifDecimalConverter(getArticlePU(getArticle(item), dbArticles, location) * item.qte / 1.2)}€</p>
                    </td>
                    <td>
                        <p>${tarifDecimalConverter(getArticlePU(getArticle(item), dbArticles, location) * item.qte)}€</p>
                    </td>
                </tr>
                
                    `
    })

    if (totalPanier.combos > 0) {

        htmlBody += `<tr class="ligne-discount">
        <td colspan="2" class="col2">
        <h3>KITS PLANCHE+COMBI</h3>
        <p>Réductions appliquées pour les ensembles planche &amp; combinaison</p>
        </td>
        <td>
        </td>
        <td>
        <p>${totalPanier.combos}</p>
        </td>
        <td>
        <p>- ${tarifDecimalConverter(totalPanier.difference)}€</p>
        </td>
        <td>
        </td>
        <td>
        <p>- ${tarifDecimalConverter(totalPanier.difference * totalPanier.combos)}€</p>
        </td>
        </tr>`
    }

    htmlBody += `     <tr class="ligne-total">
                    <td colspan="2" class="col2">
                        <h3>TARIF TOTAL DU PANIER</h3>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                    <td>
                        <p>${tarifDecimalConverter((totalPanier.total - totalPanier.difference * totalPanier.combos) / 1.2)}€</p>
                    </td>
                    <td>
                        <p>${tarifDecimalConverter(totalPanier.total - totalPanier.difference * totalPanier.combos)}€</p>
                    </td>
                </tr>
            </table>

        </div>
    </div>`;

    if (location.commentaire.length > 0) { //mail wally
        htmlBody += `
    <div class="main-container">
        <div class="location-step3-infos-client">
            <h3>${destinataire === "wally" ? "Commentaire client" : "Votre commentaire"}</h3>
            <div>
            <p>${location.commentaire}</p>
            </div>
        </div>
    </div>`;
    }

    if (destinataire === "wally") { //mail wally
        htmlBody += `
    <div class="main-container">
        <div class="location-step3-infos-client">
            <h3>Coordonnées client</h3>

            <div class="location-step3-infos-client-content">
                <table>
                    <tr>
                        <td>
                        <h4>${client.prenom + " " + client.nom}</h4>
                        <p>${"Téléphone : " + client.tel}</p>
                        <p>${"Email : " + client.email}</p>
                        </td>
                        <td>
                        <p>${"Téléphone 2 : " + client.tel2}</p>
                        ${client.adresse_vacances != "" ?
                `<p>Adresse de vacances : ${client.adresse_vacances}</p>`
                :
                null
            }
                        </td>

                    </tr>
                </table>

            </div>
        </div>
    </div>`

    } else { // pour le mail  client
        htmlBody += `
    <div class="main-container">
        <div class="location-step3-infos-client">
            <h3>Nous Contacter</h3>
            <div class="location-step3-infos-client-content">
                <table>
                    <tr>
                        <td>
                        <h4>Wally Glisse</h4>
                        <p>Téléphone : +33(0) 6 19 07 05 53 </p>
                        <p>Email : wallyglisse@gmail.com</p>
                        </td>
                        <td>
                        <h4>Point de retrait du matériel : </h4>
                        <p>Ecole de surf Wally Glisse</p>
                        <p>Plage du Lion, parking super sud</p>
                        <p>33680, lacanau Océan</p>
                        </td>

                    </tr>
                </table>

            </div>
        </div>
    </div>`

    }

    htmlBody += `

</body>

</html>

`;

    return htmlBody;

}